import API from '@/services/config/config.js'

export default {
    getRegisteredControlDrug ({page, count, id, q, orderBy, order}) {
        const param = {page, count, id, q, orderBy, order}
        if(param['id']){
            return API.get('/controlDrugAdministrations/?page=' +page + '&count='+count + '&resident='+id)
            .then(response => {
                return response.data
            })
        }
        else{
            return API.get('/controlDrugAdministrations/', {params:param})
            .then(response => {
                return response.data
            })
        }
        
    },
    deleteRegisteredControlDrug (id) {
        return API.delete('/controlDrugAdministrations/' + id)
            .then(response => {
                return response.data    
            })
    },
    registerControlDrug (controlDrug) {
        return API.post('/controlDrugAdministrations', controlDrug)
    },
    patchControlDrug (id, controlDrug) {
        return API.patch('/controlDrugAdministrations/' + id, controlDrug)
            .then(response => {
                return response.data
            })
    },
}